(function () {
  var modal;
  var lastTrigger;
  var allowedStatuses = { active: true, "sample-review": true };

  function absoluteUrl(path) {
    return new URL(path || "/", window.location.origin).toString();
  }

  function escapeAttribute(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function titleFor(tool) {
    if (tool.type === "animated-diagram-only") return "Embed this animated diagram";
    if (tool.type === "animated-calculator-canvas" || tool.type === "animated-calculator-svg") return "Embed this animation calculator";
    return "Embed this calculator";
  }

  function buildIframeCode(embedUrl, height) {
    return [
      "<iframe",
      '  src="' + escapeAttribute(embedUrl) + '"',
      '  width="100%"',
      '  height="' + escapeAttribute(height) + '"',
      '  style="border:0; max-width:100%;"',
      '  loading="lazy">',
      "</iframe>"
    ].join("\n");
  }

  function getTool(button) {
    var registry = window.FirgelliToolRegistry || {};
    return registry[button.dataset.toolSlug];
  }

  function track(eventName, button, extra) {
    if (!window.FirgelliEmbedAnalytics || typeof window.FirgelliEmbedAnalytics.track !== "function") return;

    var tool = getTool(button);
    if (!tool) return;

    window.FirgelliEmbedAnalytics.track(eventName, Object.assign({
      calculatorSlug: tool.slug,
      calculatorType: tool.type,
      height: tool.height
    }, extra || {}));
  }

  function openModal(button) {
    var tool = getTool(button);
    if (!tool || !allowedStatuses[tool.status] || !tool.embedUrl) return;

    lastTrigger = button;
    var title = modal.querySelector("#firgelli-tool-embed-modal-title");
    var code = modal.querySelector("[data-firgelli-tool-embed-code]");
    var preview = modal.querySelector("[data-firgelli-tool-embed-preview]");
    var previewWrap = modal.querySelector("[data-firgelli-tool-embed-preview-wrap]");
    var status = modal.querySelector("[data-firgelli-tool-embed-status]");
    var embedUrl = absoluteUrl(tool.embedUrl);
    var height = tool.height || 700;
    var shopifyEmbedUrl = window.location.origin + "/pages/tool-embed";
    var canPreview = window.FirgelliToolEmbedPreviewEnabled === true || embedUrl.indexOf(shopifyEmbedUrl) !== 0;

    title.textContent = titleFor(tool);
    code.value = buildIframeCode(embedUrl, height);
    if (previewWrap && preview) {
      if (canPreview) {
        previewWrap.hidden = false;
        preview.src = embedUrl;
        preview.height = Math.min(height, 440);
      } else {
        previewWrap.hidden = true;
        preview.removeAttribute("src");
      }
    }
    if (status) status.textContent = "";

    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    code.focus();
    code.select();
    track("embed_modal_open", button, { height: height });
  }

  function closeModal() {
    if (!modal) return;
    var preview = modal.querySelector("[data-firgelli-tool-embed-preview]");
    var previewWrap = modal.querySelector("[data-firgelli-tool-embed-preview-wrap]");
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    if (preview) preview.removeAttribute("src");
    if (previewWrap) previewWrap.hidden = false;
    if (lastTrigger) lastTrigger.focus();
  }

  function copyCode() {
    var code = modal.querySelector("[data-firgelli-tool-embed-code]");
    var status = modal.querySelector("[data-firgelli-tool-embed-status]");
    if (!code) return;

    code.select();
    var value = code.value;
    var copied = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(value)
      : new Promise(function (resolve, reject) {
        try {
          if (document.execCommand("copy")) {
            resolve();
          } else {
            reject(new Error("Copy command failed."));
          }
        } catch (error) {
          reject(error);
        }
      });

    copied.then(function () {
      if (status) status.textContent = "Copied.";
      if (lastTrigger) track("embed_code_copy", lastTrigger);
    }).catch(function () {
      if (status) status.textContent = "Select the code and copy it manually.";
    });
  }

  function init() {
    modal = document.querySelector("[data-firgelli-tool-embed-modal]");
    if (!modal) return;

    document.addEventListener("click", function (event) {
      var button = event.target.closest(".firgelli-embed-button[data-tool-slug]");
      if (button) {
        event.preventDefault();
        track("embed_button_click", button);
        openModal(button);
        return;
      }

      if (event.target.closest("[data-firgelli-tool-embed-close]")) {
        event.preventDefault();
        closeModal();
      }
    });

    modal.querySelector("[data-firgelli-tool-embed-copy]").addEventListener("click", copyCode);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) closeModal();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
